module.exports = __webpack_public_path__ + "img/lazy-lasagna.f4bad20f.jpg";